import { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosConfig';

const API_URL = process.env.REACT_APP_API_URL || '';

const stripApiOrigin = (url) => {
  if (!url) return '';
  if (API_URL && url.startsWith(API_URL)) {
    return url.slice(API_URL.length);
  }

  try {
    const parsed = new URL(url);
    return `${parsed.pathname}${parsed.search}`;
  } catch {
    return url;
  }
};

export const toProtectedFileUrl = (fileUrl) => {
  const rawPath = stripApiOrigin(fileUrl).replace(/\\/g, '/').replace(/^\.\//, '');
  const path = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;

  if (path.startsWith('/api/')) return path;

  const parts = path.split('/').filter(Boolean);
  if (parts[0] !== 'uploads') return path;

  if (parts[1] === 'legal' && parts.length >= 4) {
    return `/api/files/legal/${encodeURIComponent(parts[2])}/${encodeURIComponent(parts[3])}`;
  }

  if (parts[1] === 'invoices' && parts[2]) {
    return `/api/files/invoices/${encodeURIComponent(parts[2])}`;
  }

  if (parts[1] === 'profile-photos' && parts[2]) {
    return `/api/files/profile-photos/${encodeURIComponent(parts[2])}`;
  }

  if (parts[1] === 'salesman-photos' && parts[2]) {
    return `/api/files/salesman-photos/${encodeURIComponent(parts[2])}`;
  }

  if (parts[1] === 'financial-reports' && parts[2]) {
    return `/api/files/financial-reports/${encodeURIComponent(parts[2])}`;
  }

  return path;
};

export const useProtectedFileUrl = (fileUrl) => {
  const [objectUrl, setObjectUrl] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fileUrl) {
      setObjectUrl('');
      setError(null);
      return undefined;
    }

    let active = true;
    let nextObjectUrl = '';
    const protectedUrl = toProtectedFileUrl(fileUrl);

    const loadFile = async () => {
      try {
        setError(null);
        const response = await axiosInstance.get(protectedUrl, { responseType: 'blob' });
        nextObjectUrl = URL.createObjectURL(response.data);

        if (active) {
          setObjectUrl(nextObjectUrl);
        } else {
          URL.revokeObjectURL(nextObjectUrl);
        }
      } catch (err) {
        if (active) {
          setObjectUrl('');
          setError(err);
        }
      }
    };

    loadFile();

    return () => {
      active = false;
      if (nextObjectUrl) URL.revokeObjectURL(nextObjectUrl);
    };
  }, [fileUrl]);

  return { objectUrl, error };
};
